import { render } from "./department.vue?vue&type=template&id=05241204&scoped=true"
import script from "./department.vue?vue&type=script&lang=js"
export * from "./department.vue?vue&type=script&lang=js"

import "./department.vue?vue&type=style&index=0&id=05241204&scoped=true&lang=css"
import "./department.vue?vue&type=style&index=1&id=05241204&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05241204"

export default script